import {
  FILE_UPLOAD_PROGRESS,
  FILE_UPLOAD_ERROR,
  FILE_UPLOAD_RESPONSE,
  FILE_UPLOAD_LOADING,
  RESET_FILE_UPLOAD,
} from '../actions/types'

const initialState = {
  response: null,
  loading: false,
  progress: null,
  errors: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FILE_UPLOAD_PROGRESS:
      return {
        ...state,
        progress: action.payload,
        loading: false,
        errors: null,
      }
    case FILE_UPLOAD_LOADING:
      return {
        loading: true,
        errors: null,
      }
    case FILE_UPLOAD_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      }
    case FILE_UPLOAD_RESPONSE:
      return {
        ...state,
        loading: false,
        errors: null,
        response: action.payload,
      }
    case RESET_FILE_UPLOAD:
      return {
        initialState,
      }
    default:
      return state
  }
}
